// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"df3263a883455991fb8b","453":"0fd0c98af15c9e964af7"}[chunkId] + ".js";
};